export const findAndRemoveFromArray = <T>(array: T[], shouldRemove: (elem: T) => boolean) => {
    const removeIndex = array.findIndex(shouldRemove);
    return [...array.slice(0, removeIndex), ...array.slice(removeIndex + 1, array.length)];
};
